export function getForm(state) {
    return forms
}

